import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import GaHelper from "lib/gaHelper";

const SET_USER_INFO = "googleAnalytics/SET_USER_INFO";
const INIT_ALL_DATA = "googleAnalytics/INIT_ALL_DATA";

const setUserInfo = createAction(SET_USER_INFO);
const initAllData = createAction(INIT_ALL_DATA);

const getGoogleAnalyticsState = ({ getState }) => {
  const bookmarkState = getState().googleAnalytics.toJS();
  return bookmarkState;
};

export const setUserInfoForGA =
  ({ gaUserId, location, gender, birthday }) =>
  (dispatch, getState) => {
    dispatch(setUserInfo({ gaUserId, location, gender, birthday }));
  };

export const removeUserInfoForGA = () => (dispatch, getState) => {
  dispatch(initAllData());
};

export const startAnalyzingNewUser = () => (dispatch, getState) => {
  const { gaUserId, location, gender, birthday } = getGoogleAnalyticsState({
    getState
  });
  if (!gaUserId) {
    GaHelper.initGAUserInfo({});
  } else {
    GaHelper.initGAUserInfo({ gaUserId, location, gender, birthday });
  }
};

const initialState = fromJS({
  gaUserId: null,
  location: null,
  gender: null,
  birthday: null
});

export default handleActions(
  {
    [SET_USER_INFO]: (state, action) => {
      const { gaUserId, location, gender, birthday } = action.payload;
      return state
        .set("gaUserId", fromJS(gaUserId))
        .set("location", fromJS(location))
        .set("gender", fromJS(gender))
        .set("birthday", fromJS(birthday));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
